import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { UngroupedProductsResponseType } from "@sellar-io/api-v2/types";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request, apiV2AssertResponse } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductUngrouped = <TData = UngroupedProductsResponseType>(
  options?: UseQueryOptions<TData, unknown, TData>,
) => {
  const { user } = useFirebaseUser();
  const { business } = useSellarCurrentBusiness();

  return useQuery<TData, unknown, TData>({
    queryKey: [user?.uid, business?.id, ServerStateKeys.UngroupedProducts],
    enabled: !!user?.uid && !!business?.id,
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `products/ungrouped`,
      }).then((res) => apiV2AssertResponse<TData>(res).data),

    refetchOnWindowFocus: false,
    ...options,
  });
};
